import { createListenerMiddleware, ListenerEffectAPI } from '@reduxjs/toolkit'
import { objectiveWorkflowApi } from '@/store/api/objectiveWorkflowApi'
import { AggregateState } from '@/store/slices/aggregateSlice'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { getLifeTimeTimeoutAccordingConstraints } from './helpers/getLifeTimeTimeoutAccordingConstraints'

export const refetchTreeAccordingConstraintMiddleware = createListenerMiddleware()

let treeValidTimeout: NodeJS.Timeout | undefined = undefined

refetchTreeAccordingConstraintMiddleware.startListening({
  matcher: objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.matchPending,
  effect: async () => {
    clearTimeout(treeValidTimeout!)
  },
})

refetchTreeAccordingConstraintMiddleware.startListening({
  matcher: objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.matchRejected,
  effect: async (action, listenerApi: ListenerEffectAPI<any, any>) => {
    const dispatch = listenerApi.dispatch

    treeValidTimeout = setTimeout(() => {
      const aggregate: AggregateState = listenerApi.getState().aggregate
      const objectiveWorkflowId = aggregate.current?.lastObjectiveWorkflow?.id

      if (action.meta.arg.originalArgs.objectiveWorkflowId !== objectiveWorkflowId) {
        // seems objective workflow id changed, no action needed
        return
      }

      dispatch(
        objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.initiate(
          { objectiveWorkflowId: action.meta.arg.originalArgs.objectiveWorkflowId },
          { forceRefetch: 1 },
        ),
      )
    }, 30_000)
  },
})

refetchTreeAccordingConstraintMiddleware.startListening({
  matcher: objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.matchFulfilled,
  effect: async (action, listenerApi: ListenerEffectAPI<any, any>) => {
    clearTimeout(treeValidTimeout!)

    const dispatch = listenerApi.dispatch
    const aggregate: AggregateState = listenerApi.getState().aggregate
    const objectiveWorkflowId = aggregate.current?.lastObjectiveWorkflow?.id

    if (!objectiveWorkflowId) {
      return
    }

    const activitiesWithAggregates: FrontActivityWithAggregate =
      listenerApi.getState().aggregate.activitiesWithAggregates

    const lifeTimeInMilliseconds = getLifeTimeTimeoutAccordingConstraints(activitiesWithAggregates.children)
    if (lifeTimeInMilliseconds === null) {
      return
    }

    treeValidTimeout = setTimeout(
      () =>
        dispatch(
          objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.initiate(
            { objectiveWorkflowId },
            { forceRefetch: 1 },
          ),
        ),
      lifeTimeInMilliseconds,
    )
  },
})
